import { Injectable } from '@angular/core';
import moment from 'moment';
import { Subject } from 'rxjs';
import { LanguageService } from '../../core/services/language.service';
import { Message } from '../../osp-ui/contract/message.contract';
import { MessageService } from '../../osp-ui/services/message.service';

type ToastContent = Pick<Message, 'summary' | 'detail'>;

type MessageData = {
  errorTime?: Date;
  currentLocale?: string;
};

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private addMethodCalledSubject = new Subject<void>();
  public isAddMethodCalled$ = this.addMethodCalledSubject.asObservable();

  constructor(
    private messageService: MessageService,
    private languageService: LanguageService,
  ) {}

  public showMessage(severity: string, content: ToastContent, data?: MessageData): void {
    this.messageService.add({
      id: crypto.randomUUID(),
      key: 'osp-toast',
      severity: severity,
      sticky: severity === 'error',
      summary: content.summary,
      ...(content.detail && { detail: content.detail }),
      ...(data && { data: data }),
    });
  }

  public showError(content: ToastContent): void {
    this.showMessage('error', content, {
      errorTime: this.getCurrentTime(),
      currentLocale: this.getCurrentLocale(),
    });
  }

  public showSuccess(content: ToastContent): void {
    this.showMessage('success', content);
  }

  public showWarning(content: ToastContent): void {
    this.showMessage('warn', content);
  }

  public showNeutral(content: ToastContent): void {
    this.showMessage('neutral', content);
  }

  public dismiss(): void {
    this.messageService.clear();
  }

  private getCurrentTime(): Date {
    return moment().toDate();
  }

  private getCurrentLocale(): string {
    return this.languageService.getCurrentLocale();
  }
}
